export default (params) => ({
  trigger: {
    name: 'content_blocks.faq.select_navigation',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
    },
    event: {
      name: 'select_navigation',
      params: {
        sub_feature: null,
      },
    },
    nonInt: false,
  },
});
